module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-header"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('div', {
    staticClass: "col col-s8"
  }, [_vm._v("XX Congresso Nazionale SIGU")]), _vm._v(" "), _c('div', {
    staticClass: "col col-s4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sigu.net",
      "target": "blank"
    }
  }, [_vm._v("SIGU.NET")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/inside/contatti/segreteria-organizzativa"
    }
  }, [_vm._v("CONTATTI")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("HOME")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17f8f893"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-header.vue
// module id = 353
// module chunks = 0